<template>
    <FKBreadCrumb :page="consent.title" >
        <FKBreadCrumbItem :page="$t('page.consents')" :to="`/consents`"/>
    </FKBreadCrumb>
    <template v-if="!has_versions">
        <ConsentForm />
        <ConsentVersionsForm/>
    </template>
    <template v-else>
        <div class="row">
            <div class="col-md-8 col-lg-9">
                <ConsentForm/>
                <ConsentVersionsForm/>
            </div>
            <div class="col-md-4 col-lg-3">
                <ConsentVersionsList/>
            </div>
        </div>
    </template>

</template>
  
<script lang="ts">
import { defineComponent } from "vue";

import ConsentForm from "@/components/FK/Consents/ConsentForm.vue";
import ConsentVersionsList from "@/components/FK/Consents/ConsentVersionsList.vue";
import ConsentVersionsForm from "@/components/FK/Consents/ConsentVersionForm.vue";
import { Consent } from "@/utils/models/consent.model";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
    name: "UpdateConsentPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ConsentForm,
        ConsentVersionsForm,
        ConsentVersionsList,
    },
    data: function () {
        return {
            consent: (this.$route.meta.consent ?? {}) as Consent,
        }
    },
    computed: {
        has_versions():boolean {
            return this.consent.current_version !== undefined;
        }
    },
});
</script>